import { call, put, takeLatest } from "redux-saga/effects";
import { CODE_REDEMPTION_REPORT_ACTION } from "./actionType";
import { CodeRedemption_Report_Action_Success, CodeRedemption_Report_ErrorAction } from "./action";
import { CodeRedemptionReport_API, } from "../../../helpers/backend_helper";
import { date_dmy_func } from "../../../components/Common/CommonFunction";


function* CodeRedemptionReport_GenFunc({ config }) {

	function formatDateRange(dateRange) {
		if (!dateRange || !dateRange.includes(" To ")) {
			return ""; // or return "Invalid date range"
		}

		const [start, end] = dateRange.split(" To ");

		const formatDate = (dateStr) => {
			const [year, month, day] = dateStr.split("-");
			return `${day}-${month}-${year}`;
		};

		return `${formatDate(start)} To ${formatDate(end)}`;
	}

	try {
		let response = yield call(CodeRedemptionReport_API, config);
		response["Mode"] = config.Mode

		response.Data = response.Data.map(item => ({
			...item,
			InvoiceDate: date_dmy_func(item.InvoiceDate),
			recordsAmountTotal: item.InvoiceAmount,
			SchemePeriod: formatDateRange(item.SchemePeriod),

			VoucherCode:
				item.VoucherCode && item.scheme_customer_party_name
					? `${item.VoucherCode}(${item.scheme_customer_party_name})`
					: item.VoucherCode,
		}));
		yield put(CodeRedemption_Report_Action_Success(response))
	} catch (error) { yield put(CodeRedemption_Report_ErrorAction()) }
}

function* CodeRedemptionReportSaga() {
	yield takeLatest(CODE_REDEMPTION_REPORT_ACTION, CodeRedemptionReport_GenFunc)
}

export default CodeRedemptionReportSaga;
